// Instrumentación del framework de rollout (§5 del plan). Una sola función aplica las
// dimensiones genéricas `rollout_feature` + `rollout_variant` + `rollout_state` a los 3
// sinks de observabilidad para que los eventos existentes se vuelvan comparables
// treatment/control. Las dimensiones son GENÉRICAS (no `menu_*`) + el slicer `rollout_feature`
// = feature_key, para soportar 2+ features vivas sin mezclar datos bajo una misma dimensión:
//   - GA4: user_properties (viajan en cada evento siguiente).
//   - Clarity: tags de sesión (filtrar replays).
//   - Sentry: tags globales (delta de errores).
//
// Es síncrona y tolerante: si un sink está apagado (tracking off / no-prod), no rompe.

import { ga4SetUserProperties } from '@utils/analytics/ga4';
import { claritySetTags } from '@utils/analytics/clarity';
import { setFeatureVersionTags } from '@utils/print/printSentry';
import type { FeatureMenuState, FeatureVariant } from './types';

export interface FeatureVersionTags {
  // feature_key del rollout (p.ej. 'menu-v2'). Es el slicer que distingue 2+ features vivas
  // bajo las mismas dimensiones genéricas en GA4/Clarity/Sentry.
  feature_key: string;
  // Variante resuelta (control/treatment). Internamente es la "version" de la feature; se
  // envía bajo la dimensión genérica `rollout_variant`.
  variant: FeatureVariant;
  // Estado per-comercio (subject_state.state). El nombre del VALOR sigue siendo menu_state-ish
  // (never_tried/exploring/...), pero la DIMENSIÓN enviada es genérica `rollout_state`.
  menu_state: FeatureMenuState | null;
}

export function applyFeatureVersionTags(tags: FeatureVersionTags): void {
  const flat = {
    rollout_feature: tags.feature_key,
    rollout_variant: tags.variant,
    rollout_state: tags.menu_state ?? undefined,
  };
  ga4SetUserProperties(flat);
  claritySetTags(flat);
  setFeatureVersionTags({
    rollout_feature: tags.feature_key,
    rollout_variant: tags.variant,
    rollout_state: tags.menu_state,
  });
}
